var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button--menu",on:{"click":function($event){return _vm.open()}}})}
var staticRenderFns = []

export { render, staticRenderFns }